module.exports = __webpack_public_path__ + "static/media/scikit.f0f50003.png";